module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/categories/stomach-b6dccc94b0e9c02f49e93e687445edff.png";